<script setup>
const props = defineProps({
  firstLabel: String,
  secondLabel: String,
});
</script>

<template>
  <div class="w-full border-b border-[#D9D9D9] pb-[25px]">
    <div class="text-3xl lg:text-6xl">
      <h1 class="flex flex-col">
        <span v-if="firstLabel" class="font-light text-[#BDBDBD]">{{
          firstLabel
          }}</span>
        <span v-if="secondLabel" class="font-semibold text-[#333333]">{{
          secondLabel
          }}</span>
      </h1>
    </div>
  </div>
</template>
